<div class="modal-header">
    <h5 class="modal-title">SMS and Calling - Terms and Conditions</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss();"></button>
</div>
<div class="modal-body">
    <p class="message-content">
        <b>Service Approval:</b> SMS and call services will be handled by Twilio, including A2P
        (Application-to-Person) approval. Approval or rejection of your application is solely determined by Twilio, and Tinsel CRM is not
        responsible for any refusals or rejections.
        <br /><br />
        <b>Fees and Charges:</b> Monthly fees may apply for using SMS and call services. These charges will be
        billed in accordance with the usage and Tinsel CRM's pricing structure.
        <br /><br />
        <b>Compliance:</b> By using these services, you agree to comply with all applicable regulations and
        guidelines governing SMS and call communications.
        <br /><br />
        <b>Limitation of Liability:</b> Tinsel CRM shall not be held liable for any service disruptions, application
        refusals, or additional fees incurred as part of the SMS and call services.
        <br /><br />
        <b>Changes to Terms:</b> Tinsel CRM reserves the right to modify these terms at any time, and continued use
        of the services constitutes acceptance of the revised terms.
        <br /><br />
        By using the SMS and call services, you acknowledge and agree to these terms.
    </p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="acceptTerms();">Agree</button>
    <button type="button" class="btn btn-secondary ms-2" (click)="modal.dismiss();">Cancel</button>
</div>